import {h, Fragment} from "preact"
import { useSizeOptions, useActions, useAppState } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"
import Select from "./elements/Select"
import { useEffect, useState, useRef } from 'preact/hooks'; // Import useEffect

const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0;

export default function BottomToolbar() {
    const { query, response } = useAppState();
    const { updateSearch } = useActions();

    const currentProductsNumber = useRef(query.products?.size)

    const from = parseInteger(query.products?.from);
    const size = parseInteger(query.products?.size); // Change to query.products?.size
    const total = parseInteger(response.products.total);
    const to = from + size;

    const loadMore = () => {            
        currentProductsNumber.current = currentProductsNumber.current + 16; // Increase the size by 16
        updateSearch({
            products: {
                size: Math.min(currentProductsNumber.current, total)
            },
        });

        localStorage.setItem("lazyloadedNum", Math.min(currentProductsNumber.current, total))
    };

    useEffect(() => {
        // Attach a scroll event listener to trigger loading more when user reaches bottom
        var resizeTimeout;
        const handleScroll = (event) => {
            if (
                window.innerHeight + window.scrollY >= document.querySelector('.ns-serp').offsetHeight // Will load more when reaching 90% from page
                && total > currentProductsNumber.current // Prevents triggering if all of the products are already shown
            ) {
                window.removeEventListener('scroll', handleScroll);
                loadMore();
                
                setTimeout(()=>{
                    window.addEventListener('scroll', handleScroll);
                }, 100)
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Empty dependency array to ensure the effect is only added once
}